var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.url
    ? _c("div", { staticClass: "trbo-a-video" }, [
        _c(
          "video",
          {
            staticClass: "trbo-a-video__player",
            attrs: { controls: "", autoplay: "", muted: "" },
            domProps: { muted: true },
          },
          [
            _c("source", { attrs: { src: _vm.url } }),
            _vm._v("\n    Your browser does not support video.\n  "),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }